import { createContext, useContext, useState } from 'react';

const RequestApprovalContext = createContext();

const initialState = {
  alertProps: { isOpen: false, status: 'success', message: '' },
  isOpenActionModal: false,
  selectedItem: null,
  actionType: null,
  isOpenDetailModal: false,
  isOpenImagePreview: false,
  selectedImagePreview: [],
  selectedTab: 'requested',
};

const initialFilterState = {
  page: 1,
  limit: 10,
  search: '',
  brand: [],
  typeId: [],
  statusProgress: [],
};

const RequestApprovalProvider = ({ children }) => {
  const [state, setState] = useState(initialState);
  const [filterState, setFilterState] = useState(initialFilterState);

  const updateState = (payload) => setState((prev) => ({ ...prev, ...payload }));
  const updateFilterState = (payload) => setFilterState((prev) => ({ ...prev, ...payload }));
  const resetState = () => setState(initialState);
  const resetFilterState = () => setFilterState(initialFilterState);

  return (
    <RequestApprovalContext.Provider value={{ updateState, updateFilterState, resetState, resetFilterState, state, filterState }}>
      {children}
    </RequestApprovalContext.Provider>
  );
};

export const useRequestApprovalState = () => {
  return useContext(RequestApprovalContext);
};

export default RequestApprovalProvider;
